<template>
    <div class="files_block resolution">
        
        <div class="card-body py-0 px-4 ">
            <div class="d-flex flex-column align-items-center">
                
                <!-- comment -->
                <div class="d-flex flex-row w-100 py-4 m-0 w-100"  v-for="chat in items">
                    <div class="d-inline-block align-middle status status-sm status-success mr-3" @click="click_photo(chat.user_id)">
                        <span class="profile-image profile-image rounded-circle d-block mt-1"
                              v-bind:style="{
                                      'background-image': 'url(' + chat.user_info.medium_img + ')',
                                      'background-size': 'cover'
                              }"
                        >
                        </span>
                    </div>
                    
                    <div class="mb-0 flex-1 text-dark">
                        <div class="d-flex">
                            <div class="text-dark fw-500">
                                {{ chat.fio}}
                            </div>
                            <span class="text-muted fs-xs opacity-70 ml-auto">
                                  {{chat.date_format}}
                            </span>
                            
                            <span href="#" class="text-muted ml-4 cursor-pointer" title="delete"  @click="remove_item(chat.id)">
                                <i class="fal fa-trash-alt"></i>
                            </span>
                        </div>
                        <p class="mb-0">
                            {{chat.message}}
                        </p>
                    </div>
                </div>
                <hr class="m-0 w-100">
                <!-- comment end -->
                
                <div class="py-3 w-100">
                    <b-form-textarea style="min-height: 130px" v-model="text" :state="text.length >= 2"  placeholder="Додати коментар..."
                                     class="form-control "
                                     size="sm"
                    ></b-form-textarea>
                    
                    <div class="text-right">
                        <button type="button" class="btn btn-lg btn-info waves-effect waves-themed mt-5 mb-5" @click="add_item" :disabled="is_dis_save">
                            <span class="fal fa-download mr-1"></span>
                            Додати
                        </button>
                    </div>
                </div>
                <!-- add comment end -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tab_message",
    
    props: {
        doc_id: {
            type: Number,
            required: true
        },
    },
    
    data() {
        return {
            text: '',
            is_dis_save: false,
            is_load : false,
            fields: [
                {
                    key: 'fio',
                    label: 'ПIБ',
                },
                {
                    key: 'message',
                    label: 'Повідомлення',
                    class:'text-justify'
                },
                {
                    key: 'date_format',
                    class : 'date_d',
                    label: 'Дата',
                },
                {
                    key : 'link_rem',
                    label: '<i data-original-title="Видалити " class="fa fa-trash"></i>',
                },
            ],
            items: [],
        }
    },
    
    created() {
        this.getItems();
    },
    
    computed: {
    
    
    },
    
    methods: {
        show_loading(flag) {
            this.$store.dispatch('memorandum_work_tabs/SET_MEM_LOAD_TAB', {
                type: this.$options.name,
                active: flag
            });
        },
        
        
        click_photo(userid) {
            EventBus.$emit("click_user_photo",userid);
            
        },
        
        async remove_item (chat_id) {
            console.log('remove_item',chat_id);
            
            this.is_load = true;
            this.show_loading(true);
            
            await api.delete('/memorandums/'+ this.doc_id +'/messages/' + chat_id).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.items = data.data;
                    this.$store.dispatch('memorandum_work_tabs/SET_MEM_TAB_COUNT', {
                        type: this.$options.name,
                        count: this.items.length,
                    });
                    
                    this.show_loading(false);
                    this.is_load = false;
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async add_item () {
            
            if(this.text.length > 2) {
                this.is_load = true;
                this.show_loading(true);
                
                await api.put('/memorandums/'+ this.doc_id +'/messages',{
                    'mes' : this.text
                }).then(({data}) => {
                    this.is_load = false;
                    this.text = '';
                    
                    if (data.status === "operation_success") {
                        
                        this.items = data.data;
                        this.$store.dispatch('memorandum_work_tabs/SET_MEM_TAB_COUNT', {
                            type: this.$options.name,
                            count: this.items.length,
                        });
                        
                        this.show_loading(false);
                        this.is_load = false;
                    }
                }).catch(err => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            }
        },
        
        
        async getItems() {
            
            this.show_loading(true);
            await api.get('/memorandums/'+ this.doc_id +'/messages').then(({data}) => {
                if (data.status === "operation_success") {
                    this.items = data.data;
                    
                    this.$store.dispatch('memorandum_work_tabs/SET_MEM_TAB_COUNT', {
                        type: this.$options.name,
                        count: this.items.length,
                    });
                    
                    this.show_loading(false);
                }
            }).catch(err => {
                this.show_loading(false);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
            
        },
        
    },
}
</script>

<style scoped>

.move_down {
    position: absolute;
    bottom: 0;
    left: 15px;
}

th i {
    color:white;
}

.fa-trash {
    cursor: pointer;
}
</style>
